module.exports = "<a href=\"{url}\" class=\"kl-text kl-text--{type} kl-text--{size} kl-text--{align} kl-text--{vertical} {class}\"\n   target=\"{target}\"\n   on-click={this.onClick($event)}\n   r-class={{'kl-text--unlink': url == 'javascript:;','kl-text--bold': isBold}}>\n  {#if this.$body}\n    {#inc this.$body}\n  {#else}\n    {#inc text}\n  {/if}\n</a>"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLText/index.html
// module id = 418
// module chunks = 0